import merge from 'lodash/merge'
import { parseResponsiveProperty, breakpointsMedia } from '@converdy/styles'

function parseGradient (gradient) {
  const {
    type = 'solid',
    color = '#ffffff',
    secondColor = '#000000',
    deg = 90,
    size = 100
  } = gradient

  switch(type) {
    case 'solid':
      return `linear-gradient(${color}, ${color})`

		case 'linearGradient':
      return `linear-gradient(${deg}deg, ${color}, ${secondColor})`

		case 'radialGradient':
			return `radial-gradient(${size}% ${size}%, ${color}, ${secondColor})`
	}
}

export default function baseBackgroundStyles(props = {}) {

  const {
    colorLayer, 
    imageLayer,
    overlayLayer,
    videoLayer,
    color,
    image,
    overlay
  } = props

  
  let jss = {}
  
  const layers = []

  if (colorLayer && color) {
    layers.push({
      image: parseGradient(color),
      repeat: 'repeat',
      size: 'auto',
      position: 'center center'
    })
  }

  if (imageLayer && image) {

    const  { src, repeat = 'repeat' , size = 'auto', position = 'center center'  } = image

    layers.unshift({
      image: `url(${src})`,
      repeat,
      size,
      position
    })
  }

  if (overlayLayer && overlay) {
    layers.unshift({
      image: parseGradient(overlay),
      repeat: 'repeat',
      size: 'auto',
      position: 'center center'
    })
  }

  /* If video layer, also render overlay above the video */ 
  if(videoLayer && overlayLayer && overlay) {
    jss = merge(
      jss,
      { 
        '& > .video-layer:before': {
            content: '""',
            width: '100%',
            height: '100%',
            position: 'absolute',
            top: '0',
            left: '0',
            zIndex: '2',
            backgroundImage: parseGradient(overlay),
            backgroundRepeat: 'repeat',
            backgroundSize: 'auto',
            backgroundPosition: 'center center'
        }
      }
    )
  }

  // Try to get a device optimized img url based on the breakpoint
  function optimizedCloudinaryUrl(imgSrc = '', breakpoint = 'desktop') {

    const CLOUDINARY_BASE = `https://res.cloudinary.com/ditbeukyz/image/upload/`

    // Todo optimize per breakppoint
    const breakpoints = {
      desktop: 1800,
      tablet: 1200,
      mobile: 1200
    }

    if(imgSrc.includes(CLOUDINARY_BASE)) {
      imgSrc.split(CLOUDINARY_BASE)[1]
      imgSrc = `url(${CLOUDINARY_BASE}w_${breakpoints[breakpoint]},f_auto/${imgSrc.split(CLOUDINARY_BASE)[1]}`
    }
    return imgSrc
  }


  if (layers.length > 0) {
    merge(
      jss,
      {
          backgroundImage: layers.map(({ image }) => optimizedCloudinaryUrl(image, 'desktop')),
          backgroundRepeat: layers.map(({ repeat }) => repeat),
          backgroundSize: layers.map(({ size }) => size),
          backgroundPosition: layers.map(({ position }) => position),
      }
    )
  }

  // Overwrite backgroundImage for different media sizes
  if(imageLayer && image && layers.length > 0) {

    merge(
      jss,
      {
        [breakpointsMedia.tablet]: {
          backgroundImage: layers.map(({ image }) => optimizedCloudinaryUrl(image, 'tablet'))  
        },
        [breakpointsMedia.mobile]: {
          backgroundImage: layers.map(({ image }) => optimizedCloudinaryUrl(image, 'mobile'))
        }
      }
    )

  }

  return jss
}

